export default "__VITE_ASSET__BHLGb6ty__"